var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0613 0H99.9852C111.04 0 120 8.35557 120 18.664V101.339C120 111.648 111.04 120 99.9852 120H20.0613C9.00687 120 0.0466309 111.648 0.0466309 101.339V18.664C0.0466309 8.35557 9.00687 0 20.0613 0Z",
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_395_790",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0147 0H99.9386C110.993 0 119.953 8.35557 119.953 18.664V101.339C119.953 111.648 110.993 120 99.9386 120H20.0147C8.96024 120 0 111.648 0 101.339V18.664C0 8.35557 8.96024 0 20.0147 0Z",
    fill: "#EFEFEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_395_790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-13.8704 107.563C-14.211 91.1031 15.7048 89.1533 55.7342 89.1533C95.7636 89.1533 131.659 91.1062 131.611 107.959C131.588 116.528 98.6368 127.648 58.6074 127.648C18.578 127.648 -13.6951 116.132 -13.8704 107.563Z",
    fill: "#ABABAB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1383 98.8359L43.6136 98.4806C44.2881 99.0215 47.9369 103.323 46.7701 103.707C45.6033 104.088 40.1907 98.6661 41.1383 98.8359Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3837 98.6818L29.8916 98.424C29.2407 98.9931 25.7942 103.437 26.9779 103.773C28.165 104.106 33.3246 98.4743 32.3837 98.6818Z",
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0644 98.9334L43.5565 98.6755C44.2074 99.2447 47.6539 103.688 46.4702 104.025C45.2832 104.358 40.1235 98.7227 41.0644 98.9334Z",
    fill: "#4A4A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6888 35.4003L48.4968 39.4728L47.4278 39.1992C47.4278 39.1992 45.6809 44.8754 44.9626 46.6396C43.5462 50.124 43.499 52.9291 43.3776 53.7373C43.1146 55.4543 44.3252 99.1253 44.3252 99.1253L40.6966 99.1882L36.6802 62.4985C36.6802 62.4985 34.8153 62.7124 34.849 62.7438L32.6435 99.1662L28.8025 99.3611C28.8025 99.3611 27.7503 64.0677 28.5259 55.643C28.8092 52.5832 28.644 53.9385 29.6995 49.495C30.4414 46.3755 31.9927 37.3752 33.8104 35.0167C34.5118 34.1078 38.6665 32.7116 42.2816 32.4506C46.0957 32.177 50.6888 35.4003 50.6888 35.4003Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6201 31.441H67.4931V102.374H62.6201V31.441Z",
    fill: "#F7F7F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5225 32.4976L67.2405 32.4504",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 37.0292L67.2403 36.9821",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 41.5607L67.2403 41.5135",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 46.0955L67.2403 46.0483",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 50.627L67.2403 50.5798",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 55.1586L67.2403 55.1115",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 59.6902L67.2403 59.6431",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 64.2217L67.2403 64.1746",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 68.7564L67.2403 68.7092",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 73.2881L67.2403 73.241",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 77.8196L67.2403 77.7725",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.5222 82.3511L67.2403 82.304",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.3806 86.8858L67.2403 86.8386",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.3806 91.4144L67.2403 91.3672",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.3806 95.949L67.2403 95.9019",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M64.3806 100.481L67.2403 100.433",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 33.3813H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 37.9128H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 42.4445H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 46.976H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 51.5107H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 56.0422H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 60.5739H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 65.1055H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 69.637H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 74.1716H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 78.7034H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 83.2349H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 87.7664H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 92.301H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 96.8329L67.2403 96.8295",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 35.1926H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 39.7242H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 44.259H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 48.7905H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 53.322H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 57.8538H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 62.3853H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 66.9199H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 71.4514H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 75.983H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 80.5146H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 85.0461H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 89.5812L67.2403 89.5778",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 94.1125H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 98.644H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 36.1016H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 40.6331H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 45.1646H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 49.6963H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 54.2278H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 58.7625H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 63.2941H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 67.8256H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 72.3572H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 76.8888H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 81.4235H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 85.9551H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 90.4866H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 95.0181H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 99.5532L67.2403 99.5498",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 34.287H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 38.8186H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 43.3501H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 47.8849H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 52.4164H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 56.948H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 61.4795H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 66.011H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 70.5459H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 75.0774H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4749 79.6089H67.2404",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 84.1405H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 88.672H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 93.2068H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9846,
    d: "M66.4343 97.7383H67.2403",
    stroke: "#999999",
    strokeWidth: 1.1277,
    strokeMiterlimit: 7.4409
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.666 40.0482L54.874 48.3126L48.5745 49.1176L53.5925 40.0985L59.666 40.0482Z",
    fill: "#C7C7C7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9868 39.4413C38.9868 39.4413 39.894 44.6427 40.6157 46.061C40.9596 46.7403 49.586 44.3125 49.586 44.3125C49.586 44.3125 50.9586 43.6899 51.3767 43.7119C51.8387 43.737 51.2317 43.9949 51.3801 44.3125C51.5926 44.7748 52.6582 44.8691 52.9516 45.0798C53.3023 45.3346 51.3801 46.8598 50.9046 46.8755C50.4291 46.8944 49.242 46.3755 49.242 46.3755C49.242 46.3755 39.2465 50.8756 38.1168 49.6995C36.9365 48.4699 34.7141 40.608 34.7141 40.608C34.7141 40.608 35.3953 39.9382 36.4947 39.3721C37.5873 38.8061 38.9868 39.4413 38.9868 39.4413Z",
    fill: "#C7C7C7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.825 26.3906C38.825 23.6075 40.909 21.3496 43.4787 21.3496C46.0484 21.3496 48.1325 23.6075 48.1325 26.3906C48.1325 29.1737 46.0484 31.4316 43.4787 31.4316C40.909 31.4316 38.825 29.1769 38.825 26.3906Z",
    fill: "#C7C7C7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.835 33.3059L41.8298 30.6989L44.7839 30.6077L44.0454 34.0229L42.9224 35.9694L40.835 33.3059Z",
    fill: "#C7C7C7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4307 68.2565C68.4307 54.2152 73.8871 42.8313 80.6148 42.8313C87.3426 42.8313 92.799 54.2152 92.799 68.2565C92.799 82.2977 68.4307 82.3009 68.4307 68.2565Z",
    fill: "#ABABAB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1981 26.7146C33.5068 25.1013 38.2584 24.0604 38.2584 24.0604C38.2584 24.0604 38.4506 21.5855 41.7757 20.6138C45.9641 19.3905 47.2018 22.5006 47.2018 22.5006C47.2018 22.5006 51.8353 21.9786 52.1861 23.0006C52.6852 24.4504 48.6654 25.8655 44.3859 26.6297C39.958 27.4221 34.7883 28.092 34.1981 26.7146Z",
    fill: "#999999"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7698 35.6298C36.252 35.5355 37.1356 38.0104 37.1356 38.0104C37.23 38.4978 35.4798 38.8437 35.3887 38.3563C35.3887 38.3563 35.2876 35.7242 35.7698 35.6298Z",
    fill: "#ABABAB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6146 67.4263C81.714 67.4263 82.6077 68.2596 82.6077 69.2848V99.751C82.6077 100.779 81.714 101.61 80.6146 101.61C79.5152 101.61 78.6216 100.779 78.6216 99.751V69.2848C78.6216 68.2596 79.5119 67.4263 80.6146 67.4263Z",
    fill: "#999999"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7985 35.6172C49.7985 35.6172 51.0698 36.2273 52.6751 36.4474C54.0948 36.6424 55.8349 36.46 56.2531 36.3468C56.5499 36.265 62.8156 31.4441 63.1933 31.2146C63.571 30.985 64.7277 30.5888 65.8912 30.5668C67.0546 30.5447 67.8842 32.1517 67.6853 32.5888C67.6549 32.6549 67.5369 33.3844 67.1086 33.2492C66.5353 33.0668 65.5742 32.0133 65.0886 32.2681C64.2421 32.7115 64.4512 32.9001 64.4512 32.9001C64.4512 32.9001 66.0396 33.8404 65.5135 34.0291C64.4343 34.4191 63.2675 33.2178 63.163 33.3153C62.9438 33.5197 58.1517 39.4066 57.0759 39.3626C57.0759 39.3626 54.6883 39.7242 52.4255 39.7368C50.1627 39.7494 48.2405 38.894 48.2405 38.894C48.2405 38.894 48.2911 37.7147 48.6789 36.8971C49.0768 36.0763 49.7985 35.6172 49.7985 35.6172Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStep4);
export default __webpack_public_path__ + "static/media/grayStep4.e8a6c3c662fdfc2f2975f1bbb5f37f79.svg";
export { ForwardRef as ReactComponent };